export default "__VITE_ASSET__DmKnK9I$__"